import React from "react";
const EditUserIcon: React.FC = () => {
  return (
    <svg
      width="28"
      height="26"
      viewBox="0 0 32 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="32" height="30" rx="5" fill="#4F93FE" />
      <path
        d="M11.243 20.997H7V16.754L18.435 5.31897C18.6225 5.1315 18.8768 5.02618 19.142 5.02618C19.4072 5.02618 19.6615 5.1315 19.849 5.31897L22.678 8.14697C22.771 8.23984 22.8447 8.35013 22.8951 8.47153C22.9454 8.59293 22.9713 8.72305 22.9713 8.85447C22.9713 8.98589 22.9454 9.11601 22.8951 9.23741C22.8447 9.35881 22.771 9.4691 22.678 9.56197L11.243 20.997ZM7 22.997H25V24.997H7V22.997Z"
        fill="white"
      />
    </svg>
  );
};

export default EditUserIcon;
